import { parsePhoneNumberFromString, type CountryCode } from "libphonenumber-js/max";

export function defaultPhoneCountry(language: string): CountryCode {
  return language.toLowerCase().startsWith("en") ? "US" : "MX";
}

/** National numbers require an explicitly selected country; no length-based guessing. */
export function bookingPhone(raw: string, country?: CountryCode): string | null {
  const input = raw.trim().replace(/^00/, "+");
  if (!input || (!input.startsWith("+") && !country)) return null;
  const phone = parsePhoneNumberFromString(input, { defaultCountry: country, extract: false });
  return phone?.isValid() ? phone.number : null;
}